import { useDispatch } from 'react-redux';

import { TAnswersState } from '../../FormContainer/types/internal';
import { isSpecialistsAvailable } from '../../../actions/isSpecialistsAvailable';
import { useCallback, useEffect, useState } from 'react';
import { EDealTypeEx } from '../../../repositories/demand/v4/create-message';
import { getGeoMapper } from '../../../utils/getGeoMapper';

export const useAvailableRealtorChoice = (answersState: TAnswersState) => {
  const dispatch = useDispatch();
  const [isAvailableChoice, setIsAvailableChoice] = useState<null | boolean>(null);

  const checkIsAvailable = useCallback(async () => {
    if (!answersState.address) {
      return false;
    }

    const geoMapper = getGeoMapper(answersState.dealTypeEx?.value as EDealTypeEx);
    const geo = geoMapper(answersState.address);
    const isAvailable = await dispatch(isSpecialistsAvailable({ ...geo }) as unknown as Promise<boolean>);

    return isAvailable;
  }, [answersState.address, dispatch]);

  useEffect(() => {
    let isMounted = true;

    (async () => {
      const isAvailable = await checkIsAvailable();
      if (isMounted) {
        setIsAvailableChoice(isAvailable);
      }
    })();

    return () => {
      isMounted = false;
    };
  }, [checkIsAvailable]);

  const isFetching = isAvailableChoice === null;

  return { isAvailableChoice, isFetching };
};
